import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=4ec4b937&scoped=true"
import script from "./InvoiceDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDialog.vue?vue&type=style&index=0&id=4ec4b937&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4b937",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec4b937')) {
      api.createRecord('4ec4b937', component.options)
    } else {
      api.reload('4ec4b937', component.options)
    }
    module.hot.accept("./InvoiceDialog.vue?vue&type=template&id=4ec4b937&scoped=true", function () {
      api.rerender('4ec4b937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/InvoiceDialog.vue"
export default component.exports